module.exports = __webpack_public_path__ + "img/icon-level.cff56ffe.svg";